"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeZone = getTimeZone;
function getTimeZone() {
    try {
        const intl = new Intl.DateTimeFormat();
        return intl.resolvedOptions().timeZone;
    }
    catch (_a) {
        return undefined;
    }
}
//# sourceMappingURL=timezone.js.map